export default "__VITE_ASSET__K_Xozlz3__"